import { FieldType, type Schema } from '@wix/wix-data-schema-types'

export const getReferringSchemas = ({
  allSchemas,
  referencedSchema,
}: {
  allSchemas: Schema[]
  referencedSchema: Schema
}): Schema[] =>
  allSchemas.filter(schema =>
    Object.values(schema.fields).some(
      field =>
        (field.type === FieldType.multiReference ||
          field.type === FieldType.reference) &&
        field.referencedCollection === referencedSchema.id,
    ),
  )
